import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { sliderTexts } from './text-content.js';
import { setTextContent, setFontSizes, localization } from './push-content.js';

export const isTouchDevice = (function setTypeDevice() {
  return 'ontouchstart' in document.documentElement;
})();

const splideReviews = document.querySelector('.splide');
const splideReviewsContainer = splideReviews.querySelector('.splide__list')
let reviewsSlider, isMobilePortrait;

setTimeout(() => {
  initSliders();
  setTextContent(document.querySelectorAll('[data-i18n]'));

  const achievementsItems = document.querySelectorAll('.achievements__item');
  let maxWidth = 0;

  achievementsItems.forEach((el) => {
    maxWidth = Math.max(maxWidth, el.offsetWidth);
  });
  
  achievementsItems.forEach((el) => {
    el.style.width = `${maxWidth}px`;
  });
  setFontSizes();
}, 1000)

window.matchMedia('(orientation: portrait)').addEventListener('change', (e) => {
  reviewsSlider.destroy();
  splideReviewsContainer.innerHTML = '';
  initSliders();
});

const swiper = new Swiper('.swiper', {
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  centeredSlides: true,
  allowTouchMove: false,
  followFinger: false,
});

swiper.on('slideChange', function () {
  const slides = document.querySelectorAll('.swiper-slide video');
  slides.forEach((video, index) => {
      if (index === swiper.activeIndex) {
          video.play().catch(err => {
            
          });
      } else {
          video.pause(); 
          video.currentTime = 0
      }
  });
});

const videos = document.querySelectorAll('.swiper-slide video');
videos.forEach((video) => {
  video.addEventListener('ended', function () {
      swiper.slideNext(); 
  });
});

function initSliders() {
  let slideReviewPerPage = 3.5,
  gap = 20,
  isPaginationDots = false,
  interval = 0,
  autoplay = false,
  drag = false,
  speed = 1;
  isMobilePortrait = false;

  // tablets
  if (window.matchMedia('(min-width: 431px)').matches) {
    slideReviewPerPage = 2.5;

    // android Pixel 8 Pro/Tab A7 lite
    if (window.matchMedia('(width: 1344px)').matches && window.matchMedia('(height: 2992px)').matches) {
      document.body.classList.remove('landscape-mobile');
      slideReviewPerPage = 1.05;
      gap = 60,
      isMobilePortrait = true;
      isPaginationDots = true;
      speed = 600;
      interval = 3000;
      autoplay = true;
      drag = true;
    }

    // mobiles landscape
    if (window.matchMedia('(max-height: 430px)').matches) {
      document.body.classList.add('landscape-mobile');
      slideReviewPerPage = 2.1;
    }
    // mobiles
  } else {
    document.body.classList.remove('landscape-mobile');
    slideReviewPerPage = 1;
    isMobilePortrait = true;
    isPaginationDots = true;
    speed = 600;
    interval = 3000;
    autoplay = true;
    drag = true;
  }

    if (
    window.matchMedia("(device-width: 440px)").matches &&
    window.matchMedia("(device-height: 956px)").matches &&
    window.matchMedia("(-webkit-device-pixel-ratio: 3)").matches
  ) {
    slideReviewPerPage = 1.2;
    gap = 30;
    isMobilePortrait = true;
    isPaginationDots = true;
    speed = 600;
    interval = 3000;
    autoplay = true;
    drag = true;
  }

  setSlidersContent();

  const language = localization.lang;

  reviewsSlider = new Splide(splideReviews, {
    autoScroll: {
      speed,
    },
    type: 'loop',
    direction: language === 'ar' || language === 'he' ? 'rtl' : 'ltr',
    focus: 'center',
    perMove: 1,
    padding: { left: 20, right: 20 },
    flickMaxPages: 1,
    flickPower: 70,
    dragMinThreshold: 1,
    clones: 6,
    fixedHeight: true,
    arrows: false,
    pauseOnFocus: false,
    autoplay,
    interval,
    perPage: slideReviewPerPage,
    gap,
    drag,
    pagination: isPaginationDots,
  });
  reviewsSlider.mount(!isMobilePortrait ? { AutoScroll } : "");
}

function setSlidersContent() {
  const reviewSlide = document.createElement('li');
  reviewSlide.classList.add('splide__slide');
  reviewSlide.classList.add('review');
  reviewSlide.innerHTML = `
    <div class='review__title'>
      <div class='review__title-text'>
        <span class='divtext'></span>
      </div>
      <div class='review__title-rating'></div>
    </div>
    <p class='review__text'></p>
    <p class='review__author'></p>
    <span class='review__avatar'></span>
  `;

  sliderTexts.forEach((item, index) => {
    const cloneReviewSlide = reviewSlide.cloneNode(true);
    cloneReviewSlide.querySelector('.review__title-text span').dataset.i18n = item.title;
    cloneReviewSlide.querySelector('.review__text').dataset.i18n = item.text;
    cloneReviewSlide.querySelector('.review__author').dataset.i18n = item.author;
    cloneReviewSlide.querySelector('.review__avatar').classList.add(`review__avatar--${index + 1}`);
    splideReviewsContainer.append(cloneReviewSlide);
  });
}
